import { ApiConnectionUserMapping } from '@tassat/fred-extended-definitions';
import { Dispatch, SetStateAction } from 'react';

import { ApiConnectionsAgGrid } from './apiConnectionsAgGrid';

export interface IApiConnectionsAgGridProps{
    rowData: ApiConnectionUserMapping[];
    exportData: boolean;
    setExport: Dispatch<SetStateAction<boolean>>;
    features: {
        fireblocks: { api: boolean };
    };
}

export default ApiConnectionsAgGrid;